.projectSection {
  padding-inline: 2rem;
}

.heading {
  margin-bottom: 20px;
  color: var(--secondary-color);
}

.card {
  display: block;
  grid-template-columns: 65% 1fr;
  border: 1px solid var(--secondary-color);
  border-radius: 10px;
  margin-bottom: 20px;
  font-family: "Nunito Variable", sans-serif;
}

.infoSpan {
  display: inline-block;
  padding: 27px 22px 15px;
  line-height: var(--line-height);
}

.infoSpan p {
  margin-top: 15px;
}

.techStack {
  font-size: var(--small-text);
  display: inline-block;
  margin-top: 10px;
}

.imageContainer {
  display: flex;
  border-radius: 0 0 10px 10px;
  overflow: hidden;
}

.imageContainer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s linear;
}

@media (prefers-color-scheme: light) {
  .imageContainer {
    border-top: 1px solid var(--primary-color);
  }
}

@media (prefers-color-scheme: dark) {
  .imageContainer {
    border-top: 1px solid var(--secondary-color);
  }
}

/* Enable hover only on non-touch devices */
@media (hover: hover) and (pointer: fine) {
  .imageContainer img:hover {
    transform: scale(1.03);
  }
}

/* Remove motion for users who request reduced motion effects */
@media (prefers-reduced-motion) {
  .imageContainer img:hover {
    transform: none;
  }
}

/* Tablet */
@media (min-width: 768px) {
  .heading {
    padding-bottom: 17px;
  }
  .card {
    margin-bottom: 43px;
  }
  .infoSpan {
    padding: 47px 43px 30px;
  }
  .infoSpan p {
    line-height: var(--line-height);
  }
  .techStack {
    line-height: var(--line-height);
  }
}

/* Desktop */
@media (min-width: 1024px) {
  .projectSection {
    padding: 3rem 5rem;
  }
  .card {
    display: grid;
    border-radius: 25px;
  }
  .infoSpan {
    display: initial;
    padding: 2.5rem;
    line-height: initial;
  }
  .imageContainer {
    display: initial;
    border-radius: 0 25px 25px 0;
    border-top: none;
  }
  /* Color scheme when device's theme is light mode */
  @media (prefers-color-scheme: light) {
    .card {
      background-color: var(--secondary-color);
    }
    .imageContainer {
      border-left: 1px solid var(--primary-color);
    }
  }
  /* Color scheme when device's theme is dark mode */
  @media (prefers-color-scheme: dark) {
    .imageContainer {
      border-left: 1px solid var(--secondary-color);
    }
  }
}
